import { useState } from 'react';
import { buildFileUrl } from './api';

const CURRENT_YEAR = new Date().getFullYear();
const YEARS = Array.from({ length: CURRENT_YEAR - 2022 + 1 }, (_, i) => CURRENT_YEAR - i);

// periodMode:
//   "none"         — без выбора периода, генерим сразу
//   "years"        — только года (multi-select), напр. для обработок
//   "days60_years" — 30/60/180/365 дн. + года (для веса)
//   "days_years"   — 30/180/365 дн. + года (для питания, ухода)
//   "months_years" — 2/6/12 мес. + года (для лечения)
//   "years_back"   — 6 мес./1/2/3/5 лет + года (для отчёта по симптомам)

const DAY_OPTIONS = {
  days60_years:  [30, 60, 180, 365],
  days_years:    [30, 180, 365],
  months_years:  [60, 180, 365],
  // Для отчёта по симптомам нужна глубина в несколько лет
  years_back:    [180, 365, 730, 1095, 1825],
};

const MONTH_LABELS = {
  60:   '2 мес.',
  180:  '6 мес.',
  365:  '12 мес.',
  730:  '2 года',
  1095: '3 года',
  1825: '5 лет',
};

function PeriodPickerSheet({ periodMode, onSelect, onClose }) {
  const dayOpts = DAY_OPTIONS[periodMode] || [];
  const [selDays, setSelDays] = useState(null);
  const [selYears, setSelYears] = useState([]);

  const toggleDay = (d) => {
    setSelYears([]);
    setSelDays(prev => (prev === d ? null : d));
  };

  const toggleYear = (y) => {
    setSelDays(null);
    setSelYears(prev =>
      prev.includes(y) ? prev.filter(x => x !== y) : [...prev, y]
    );
  };

  const canSubmit = selDays !== null || selYears.length > 0;

  const handleSubmit = () => {
    if (selDays !== null) {
      onSelect(`${selDays}d`);
    } else if (selYears.length > 0) {
      onSelect(selYears.sort((a, b) => a - b).join(','));
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-sheet" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <span className="modal-title">Выберите период</span>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        {dayOpts.length > 0 && (
          <div className="period-group">
            <div className="period-group-label">
              {periodMode === 'months_years' ? 'Последних месяцев'
                : periodMode === 'years_back' ? 'За период'
                : 'Последних дней'}
            </div>
            <div className="period-chips">
              {dayOpts.map(d => (
                <button
                  key={d}
                  className={`period-chip ${selDays === d ? 'period-chip-active' : ''}`}
                  onClick={() => toggleDay(d)}
                >
                  {MONTH_LABELS[d] || `${d} дн.`}
                </button>
              ))}
            </div>
          </div>
        )}

        <div className="period-group">
          <div className="period-group-label">По году</div>
          <div className="period-chips">
            {YEARS.map(y => (
              <button
                key={y}
                className={`period-chip period-chip-year ${selYears.includes(y) ? 'period-chip-active' : ''}`}
                onClick={() => toggleYear(y)}
              >
                {y}
              </button>
            ))}
          </div>
        </div>

        <button
          className="upload-submit"
          onClick={handleSubmit}
          disabled={!canSubmit}
        >
          Создать PDF
        </button>
      </div>
    </div>
  );
}


export default function SectionHeader({
  title, subtitle, pdfPath, pdfName,
  periodMode = 'none',
  sectionKey, docs, onDocsClick,
}) {
  const [step, setStep] = useState(null); // null | 'period'
  const sectionDocs = sectionKey ? (docs?.[sectionKey] || []) : [];

  const openPdf = (period) => {
    if (!pdfPath) return;
    const extraParams = period ? { period } : {};
    const url = buildFileUrl(pdfPath, extraParams);
    window.open(url, '_blank');
    setStep(null);
  };

  const handlePdfClick = () => {
    if (!pdfPath) return;
    if (periodMode === 'none') {
      openPdf(null);
    } else {
      setStep('period');
    }
  };

  return (
    <>
      <div className="section-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <h2 className="section-title">{title}</h2>
          {subtitle && <span className="section-subtitle">{subtitle}</span>}
        </div>
        <div className="section-actions">
          {sectionKey && (
            <button
              className={`clip-btn ${sectionDocs.length > 0 ? 'clip-btn-active' : ''}`}
              onClick={() => onDocsClick && onDocsClick(sectionKey)}
              title="Документы"
            >
              📎{sectionDocs.length > 0 && <span className="clip-count">{sectionDocs.length}</span>}
            </button>
          )}
          {pdfPath && (
            <button className="pdf-btn" onClick={handlePdfClick}>
              📮
            </button>
          )}
        </div>
      </div>

      {step === 'period' && (
        <PeriodPickerSheet
          periodMode={periodMode}
          onSelect={(p) => openPdf(p)}
          onClose={() => setStep(null)}
        />
      )}
    </>
  );
}
